import { render, staticRenderFns } from "./MaterialCardSbaDashboard.vue?vue&type=template&id=f7848cbe&scoped=true&"
import script from "./MaterialCardSbaDashboard.vue?vue&type=script&lang=js&"
export * from "./MaterialCardSbaDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MaterialCardSbaDashboard.vue?vue&type=style&index=0&id=f7848cbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7848cbe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VCol,VIcon,VRow})
